var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import deepEqual from 'fast-deep-equal';
import { createUIElement, useStateValue } from "../helpers";
import { Dropdown } from "../controls/Dropdown";
import { Icon } from "../Icon";
import { Checkbox } from "../controls/Checkbox";
import { FilterItem, FilterItemLabel } from './styled';
import { getCaption, selectAll } from './utils';
import { FilterMenu, FilterMenuBody } from "../FilterMenu";
import { ColumnGroupsLayout } from "../ColumnGroupsLayout";
import { ACTION_VIEW } from "../Dialog";
import { SelectButton } from "../controls";
import { CommandActions } from "../CommandActions";
import { STACK_DIRECTION, STACK_GAP, StackView } from "../StackView";
import { DEFAULT_TEXTS } from './helpers';
import { FilterIcon } from './svg';
export var dataSelectorId = {
    menu: 'popover-menu',
    mainButton: 'advanced-filter-main-button',
    filterIcon: 'advanced-filter-icon',
    allButton: 'advanced-filter-all-button',
    noneButton: 'advanced-filter-none-button',
    checkbox: 'advanced-filter-checkbox',
    apply: 'advanced-filter-apply-button',
    cancel: 'advanced-filter-cancel-button'
};
export var AdvancedFilter = createUIElement('AdvancedFilter', function (_a, ref) {
    var className = _a.className, _b = _a.value, value = _b === void 0 ? [] : _b, label = _a.label, options = _a.options, onChange = _a.onChange, texts = _a.texts, disabled = _a.disabled, _c = _a.comparator, comparator = _c === void 0 ? deepEqual : _c, size = _a.size, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "value", "label", "options", "onChange", "texts", "disabled", "comparator", "size", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var uiTexts = __assign(__assign({}, DEFAULT_TEXTS), texts);
    var uniqValue = value || [];
    var _d = useStateValue(uniqValue, [uniqValue]), getValue = _d.getValue, setValue = _d.setValue;
    var maxLength = options.cols.reduce(function (res, column) {
        var colItems = 0;
        column.groups.forEach(function (group) {
            colItems += group.items.length;
        });
        return res + colItems;
    }, 0);
    var renderOptionsData = function (rowKey, groupKey, optionsData) {
        return (React.createElement(StackView, { direction: STACK_DIRECTION.column, gap: STACK_GAP.s }, optionsData.map(function (_a, optionKey) {
            var iconSrc = _a.iconSrc, label = _a.label, value = _a.value, testId = _a.testId;
            var checked = getValue().some(function (i) {
                return comparator(i, value);
            });
            return (React.createElement(FilterItem, { key: "advanced-filter-menu-option-" + rowKey + "-" + groupKey + "-" + optionKey },
                React.createElement(Checkbox, { onChange: function (isChecked) {
                        var nextValue = getValue().filter(function (i) { return !comparator(i, value); });
                        if (isChecked) {
                            nextValue = __spreadArrays(nextValue, [value]);
                        }
                        setValue(nextValue);
                    }, "data-selector-id": testId || dataSelectorId.checkbox, checked: checked },
                    React.createElement(FilterItemLabel, null,
                        iconSrc && (React.createElement(Icon, { key: "advanced-filter-menu-option-icon-" + rowKey + "-" + groupKey + "-" + optionKey, src: iconSrc })),
                        React.createElement("span", null, label)))));
        })));
    };
    var columns = options.cols.map(function (_a, rowKey) {
        var groups = _a.groups;
        return {
            groups: groups.map(function (_a, groupKey) {
                var title = _a.title, optionsData = _a.items;
                return {
                    title: title,
                    render: function () { return renderOptionsData(rowKey, groupKey, optionsData); }
                };
            })
        };
    });
    return (React.createElement(Dropdown, { ref: ref, renderControl: function (_a) {
            var button = _a.button, isActive = _a.isActive;
            return (React.createElement(SelectButton, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || dataSelectorId.mainButton, ref: button.ref, style: style, className: "vm-AdvancedFilter " + className, onClick: onClick, onMouseDown: function (e) {
                    button.onMouseDown(e);
                    onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
                }, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: function (e) {
                    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
                }, onKeyUp: onKeyUp, onKeyPress: onKeyPress, active: isActive, disabled: disabled, iconBefore: React.createElement(FilterIcon, null), iconAfter: null, size: size }), getCaption({ value: getValue(), maxLength: maxLength, label: label })));
        }, renderContent: function (_a) {
            var actions = _a.actions;
            return (React.createElement(FilterMenuBody, { title: options.header, headerAddon: React.createElement(CommandActions, { items: [
                        {
                            testId: dataSelectorId.allButton,
                            text: uiTexts.all,
                            onClick: function () { return setValue(selectAll(options)); }
                        },
                        {
                            testId: dataSelectorId.noneButton,
                            text: uiTexts.none,
                            onClick: function () { return setValue([]); }
                        }
                    ] }), actions: [
                    {
                        text: uiTexts.apply,
                        testId: dataSelectorId.apply,
                        onClick: function () {
                            onChange === null || onChange === void 0 ? void 0 : onChange(getValue());
                            actions.hide();
                        }
                    },
                    {
                        text: uiTexts.cancel,
                        view: ACTION_VIEW.secondary,
                        testId: dataSelectorId.cancel,
                        onClick: function () {
                            setValue(value);
                            actions.hide();
                        }
                    }
                ], content: React.createElement(ColumnGroupsLayout, { columns: columns }) }));
        }, renderPopover: function (_a) {
            var popover = _a.popover, content = _a.content;
            return (React.createElement(FilterMenu, __assign({}, popover, { "data-selector-id": "popover-menu" }), content));
        }, onOutsideClick: function () {
            setValue(value);
        } }));
});
//# sourceMappingURL=AdvancedFilter.js.map